<template>
  <BLayoutEmpty class="b-layout-view">
    <template #container>
      <!--  -->

      <v-layout class="b-layout-view__header">
        <v-btn
          v-if="backRoute"
          :to="backRoute"
          icon
          small
          color="primary"
          class="mr-2"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <h1 class="text-h5 b-layout-view__title">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <span>{{ title }}</span>
          </v-skeleton-loader>
        </h1>

        <slot name="title-after" />
      </v-layout>

      <slot name="form" />

      <slot />

      <!--  -->
    </template>

    <template v-if="!hiddenFooter && saveMenuList && saveMenuList.length" #after>
      <v-card
        :disabled="loading"
        class="b-layout-view__buttons"
      >
        <slot name="footer">
          <BFormButtons
            :loading="loading"
            :edit-route="editRoute"
            :save-menu-list="saveMenuList"
            :skeleton="skeleton"

            :saveable="saveable"
            :editable="editable"
            :deletable="deletable"

            v-on="$listeners"
          >
            <template v-for="(_, key) in footerSlots" #[key]="props">
              <slot v-bind="props" :name="`footer.${key}`" />
            </template>
          </BFormButtons>
        </slot>
      </v-card>
    </template>

    <!--  -->
  </BLayoutEmpty>
</template>

<script>
import BLayoutEmpty from './BLayoutEmpty.vue'
import BFormButtons, { SAVE_MENUS } from '@/components/common/BFormButtons.vue'


export default {
  name: 'BLayoutView',
  components: {
    BLayoutEmpty,
    BFormButtons,
  },
  props: {
    saveMenuList: {
      type: Array,
      default: () => [
        SAVE_MENUS.SAVE_CONTINUE,
        SAVE_MENUS.SAVE,
        SAVE_MENUS.SAVE_MORE,
      ],
    },
    saveable: Boolean,
    editable: Boolean,
    deletable: Boolean,

    editRoute: {
      type: [String, Object],
    },
    backRoute: {
      type: [String, Object],
    },
    title: {
      type: String,
      required: true,
    },
    loading: Boolean,
    skeleton: Boolean,
    hiddenFooter: Boolean,
  },
  computed: {
    footerSlots() {
      return Object.entries(this.$scopedSlots).reduce((acc, [key, value]) => {
        if (key.includes('footer.')) {
          const footerKey = key.replace(/^footer\./, '')
          acc[footerKey] = value
        }
        return acc
      }, {})
    },
  },
}
</script>

<style lang="scss">

$height-header: 64px;
$height-title: 72px;
$correct: $height-header + $height-title;

.b-layout-view {
  &__header {
    display: flex;
    align-items: center;
  }

  &__title {
    width: 100%;
    height: 100%;
    margin-left: 10px;
    font-size: 20px !important;
  }

  &__buttons {
    position: sticky !important;
    top: 0;
    bottom: 0;
    z-index: 5;
    padding: 12px;
    margin-top: auto;
    background: $color-white;
  }
}
</style>
